import React from "react";
import Header from "./components/header";
import Hero from "./components/hero";
import KobikuulPromoModal from "../../../components/kobikuul/KobikuulPromoModal";

export default function HomeTwo() {
  return (
    <div>
      <Header />

      <Hero />

      {/* MTN showcase programme (2026-09-04): the brochure QR codes land on
          this page, which otherwise has no visible Kobikuul entry point.
          Self-gating — see lib/kobikuul-promo. */}
      <KobikuulPromoModal />
    </div>
  );
}
